import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import {
  MutationCache,
  QueryCache,
  QueryClient,
  QueryClientProvider,
} from "@tanstack/react-query";
import App from "./App";
import { AuthGate } from "./auth/AuthGate";
import { AppErrorBoundary } from "./components/AppErrorBoundary";
import { GlobalErrorLayer } from "./components/GlobalErrorLayer";
import { notifyUnexpectedError, wasErrorNotified } from "./errors";
import "./index.css";

const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error) => {
      if (!wasErrorNotified(error)) {
        notifyUnexpectedError(error, "query");
      }
    },
  }),
  mutationCache: new MutationCache({
    onError: (error) => {
      if (!wasErrorNotified(error)) {
        notifyUnexpectedError(error, "mutation");
      }
    },
  }),
  defaultOptions: {
    queries: {
      staleTime: 30 * 1000, // D-31
      refetchOnWindowFocus: false, // D-31
      retry: 1, // D-31
    },
  },
});

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("#root element missing in index.html");
createRoot(rootEl).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <GlobalErrorLayer />
      <AppErrorBoundary>
        <AuthGate>
          <App />
        </AuthGate>
      </AppErrorBoundary>
    </QueryClientProvider>
  </StrictMode>,
);
